import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { silentLogout } from "store/bailiff/login/login.action";
import { isLoggedSelector } from "store/user/auth/user_auth.selector";
//
//component
//redux
//selector
//actions
const TriggerLogOut = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const Alogged = useSelector(isLoggedSelector);

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (Alogged === false) {
      console.log("silent logout");
      dispatch(silentLogout());
    }
  }, [dispatch, Alogged]);
  // -------------------------- RETURN --------------------------

  return <></>;
};
export default TriggerLogOut;
